import { IconKey ,IconMoneybag} from '@tabler/icons';

// constant
const icons = {
    IconKey,
    IconMoneybag
};
//

const CommissionRatna = {

    id: 'commission_ratna',
    title: 'Commission Ratna',
    type: 'group',
    display_id:'S',
    icon: icons.IconMoneybag,
    children: [
        {
            id: 'transaction_reports',
            title: 'Transaction Report',
            type: 'item',
            display_id:56,
            url: '/Department/transaction_reports',
            breadcrumbs: false
        },
    ]
}

export default CommissionRatna;
